import fb from "@bd-core/firebase";
import CONFIG from "@bd-core/config";
import { currentPageIsMainRoom } from "@bd-stores/user-progress";
// import { serverTimestamp } from "firebase/database";

export const updateAttributes = (data) => {
    return fb.update(`${fb.teamAttributesPath}`, data);
};

export const getAttributes = () => {
    return fb.get(`${fb.teamAttributesPath}`);
};

export const saveFinalRoomAnswers = (roomId, answers) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        finalAnswers: answers,
    });
};

export const setRoomStarted = async (roomId) => {
    let isStarted = null;
    await fb
        .get(`${fb.roomsPath}/${roomId}/startedAt`)
        .then((snapshot) => {
            isStarted = snapshot.val();
        })
        .catch((error) => {
            console.error(error);
        });
    if (isStarted) return;

    const rooms = CONFIG?.game?.rooms || [];
    const room = rooms.find((r) => r?.id == roomId);
    const timer = room?.room?.time_config?.timer || 0;

    const startedAt = Math.floor(Date.now() / 1000); //serverTimestamp();
    const shouldFinishedAt = startedAt + timer * 60;
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        startedAt,
        shouldFinishedAt,
    });
};

export const setRoomFinished = async (roomId) => {
    let isFinihsed = null;
    await fb
        .get(`${fb.roomsPath}/${roomId}/finishedAt`)
        .then((snapshot) => {
            isFinihsed = snapshot.val();
        })
        .catch((error) => {
            console.error(error);
        });
    if (isFinihsed) return;

    const finishedAt = Math.floor(Date.now() / 1000); //serverTimestamp();
    return fb.update(`${fb.roomsPath}/${roomId}`, { finishedAt });
};

export const updateCurrentTimer = (roomId, updatedTime) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        shouldFinishedAt: updatedTime,
    });
};

export const updateCurrentScreen = (roomId, screenId) => {
    const isCurrentPageMainroom = currentPageIsMainRoom();
    if (isCurrentPageMainroom) return;

    return fb.update(`${fb.roomsPath}/${roomId}`, { currentScreen: screenId });
};

export const updateFinalRoomAnswer = (roomId, answer) => {
    return fb.update(`${fb.roomsPath}/${roomId}/finalAnswers`, answer);
};

export const getFinalRoomAnswers = (roomId) => {
    return fb.get(`${fb.roomsPath}/${roomId}/finalAnswers`);
};

export const updateRoomAnswer = (roomId, answers) => {
    return fb.update(`${fb.roomsPath}/${roomId}/answers`, answers);
};

export const removeRoomAnswer = (roomId, key) => {
    let path = `${fb.roomsPath}/${roomId}/answers`;
    if (key) path += `/${key}`;
    return fb.remove(path);
};

export const removeRoomAnswers = () => {
    return fb.remove(`${fb.roomsPath}`);
};

export const getRoomAnswers = (roomId) => {
    return fb.get(`${fb.roomsPath}/${roomId}/answers`);
};

export const maybeUpdateRoomStatus = (roomId, roomStatus) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        status: roomStatus,
    });
};

export const setAllRoomIsCompleted = (isAllRoomcompleted) => {
    return fb.update(`${fb.teamAttributesPath}`, {
        allRoomIsCompleted: isAllRoomcompleted,
    });
};

export const updatePlayerPageId = (pageId) => {
    return fb.update(`${fb.currentPlayerPath}`, {
        currentPageId: pageId,
    });
};

export const updatePlayersPageIdByID = (playerId, pageId) => {
    return fb.update(`${fb.playersPath}/${playerId}`, {
        currentPageId: pageId,
    });
};

export const setMiddleState = (roomId) => {
    fb.update(`${fb.teamAttributesPath}`, { isMiddleState: true });
    fb.update(`${fb.roomsPath}/${roomId}`, { isMiddleState: true });
};

export const updateProfileFirebase = (data) => {
    return fb.update(fb.currentPlayerPath, data);
};

export const updateTeamConnectorState = (data) => {
    return fb.update(`${fb.teamAttributesPath}/teamconnector`, data);
};

export const getTeamConnectorState = () => {
    return fb.get(`${fb.teamAttributesPath}/teamconnector`);
};

export const setTimeSpentToFinish = (roomId, timeSpend) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        timeSpend: timeSpend,
    });
};

export const setIsRoomTimeOut = (roomId) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, { isTimeOut: true });
};

export const setIsTeamConnectorFinished = (isTeamConnectorFinished) => {
    return fb.update(`${fb.teamAttributesPath}`, {
        isTeamConnectorFinished: isTeamConnectorFinished,
    });
};

export const setTotalAttempt = (roomId, attempt) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, { totalAttempt: attempt });
};

export const setRoomTotalScores = (roomId, score) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, { totalScore: score });
};

export const setTeamLogos = (roomId, logo) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, { logo: logo });
};

export const setRadioOn = (roomId, userIds) => {
    return fb.update(`${fb.roomsPath}/${roomId}/players`, userIds);
};

export const removeRadioState = (roomId, userId) => {
    let path = `${fb.roomsPath}/${roomId}/players`;
    if (userId) path += `/${userId}`;
    return fb.remove(path);
};

export const setHasSeenGameIntro = () => {
    return fb.update(`${fb.currentPlayerPath}`, { hasSeenGameIntro: true });
};

export const setCurrentChallengeIndex = (challengeIndex) => {
    return fb.update(`${fb.teamAttributesPath}`, {
        currentChallengeIndex: challengeIndex,
    });
};

export const setChangingLeaderAttributes = (newLeaderAttributes) => {
    return fb.update(`${fb.teamAttributesPath}`, { newLeaderAttributes });
};

export const setLeader = (playerId) => {
    return fb.update(`${fb.teamAttributesPath}`, { leader: playerId });
};

export const addLeaderHistory = (playerId) => {
    return fb.push(`${fb.teamAttributesPath}/leaderHistory`, playerId);
};

export const setIsLeaderChanged = (roomId, isChanged) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        isLeaderChanged: isChanged,
    });
};

export const deleteChangingLeaderAttributes = () => {
    return fb.remove(`${fb.teamAttributesPath}/newLeaderAttributes`);
};

export const setDraggingAttributes = (roomId, isDragging, playerId = 0) => {
    return fb.set(`${fb.roomsPath}/${roomId}/draggingState`, {
        isDragging,
        playerId,
    });
};

export const setEmailPhishingAction = (roomId, action) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, { emailPhishing: action });
};

export const updatePlayerAttributes = (data) => {
    return fb.update(`${fb.currentPlayerPath}`, data);
};

export const setGameFinished = () => {
    return fb.set(`${fb.teamAttributesPath}/isFinished`, true);
};

export const setPostCardSent = () => {
    return fb.update(`${fb.teamAttributesPath}`, {
        isPostcardSent: true,
    });
};

export const setIsSendingPostCard = () => {
    return fb.update(`${fb.teamAttributesPath}`, {
        isSendingPostcard: true,
    });
};
